export const c_expandable_section_m_indented__content_PaddingLeft = {
  "name": "--pf-c-expandable-section--m-indented__content--PaddingLeft",
  "value": "calc(calc(0.25rem + 0.5rem) + 1em)",
  "var": "var(--pf-c-expandable-section--m-indented__content--PaddingLeft)"
};
export default c_expandable_section_m_indented__content_PaddingLeft;